module.exports = __webpack_public_path__ + "img/bt.a14c6695.svg";